import { Component, computed, Signal, WritableSignal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ButtonBadgeComponent } from 'src/app/common/button-badge/button-badge.component';
import { NotificationLinkComponent } from 'src/app/common/notification-link/notification-link.component';
import { Notification } from "src/app/interfaces/notification";
import { AuthService } from 'src/app/services/Auth/auth.service';
import { NotificationsService } from 'src/app/services/Notifications/notifications.service';

@Component({
  selector: 'header-notifications',
  imports: [
    ButtonBadgeComponent,
    NotificationLinkComponent
  ],
  templateUrl: './notifications-v1.component.html',
  styleUrl: './notifications-v1.component.scss'
})
export class NotificationsV1Component {
  items: WritableSignal<Notification[]>;
  unreadCount: Signal<number> = computed(() => this.items().filter(el => !el.read_at).length);
  linkPrefix!: string;

  constructor(public notificationApi: NotificationsService,
              private route: ActivatedRoute,
              public auth: AuthService
  ) {
    route.url.subscribe(segments => {
      this.linkPrefix = segments.join('/');
    });

    this.items = this.notificationApi.getNotifications();
  }

  ngOnInit() {
    this.notificationApi.fetchNotifications();
  }
}
